import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { User } from "../pages/models/users";
import * as Secure from "secure-ls";
import { Item, TransferItem } from "../pages/models/store";
import {
  BehaviorSubject,
  forkJoin,
  merge,
  Observable,
  of,
  Subject,
  timer,
} from "rxjs";
import {
  distinctUntilChanged,
  map,
  shareReplay,
  startWith,
} from "rxjs/operators";
import { StoreService } from "../pages/services/store.service";
import { switchMap } from "rxjs-compat/operator/switchMap";
import { NbMenuItem } from "@nebular/theme";
import { WebOrder } from "../pages/models/sales";
import { SalesService } from "../pages/services/sales.service";
@Injectable({
  providedIn: "root",
})
export class SharedService implements OnDestroy {
  user: User;
  secure = new Secure();
  private transferredItems = new BehaviorSubject<TransferItem[]>([]);
  getTransferredItems = this.transferredItems.asObservable();
  private webOrders = new BehaviorSubject<WebOrder[]>([]);
  getWebOrders = this.webOrders.asObservable();
  basketData = new BehaviorSubject<Item[]>([]);
  getBasketData = this.basketData.asObservable();
  menuItem: NbMenuItem;
  manual$ = new Subject<void>();
  orderMenu: NbMenuItem;

  constructor(
    private http: HttpClient,
    private storeService: StoreService,
    private saleService: SalesService
  ) {}
  setUser(user: User) {
    this.secure.set("app_run_time", JSON.stringify(user));
  }
  setTransferredItems(transferredItems: TransferItem[]) {
    this.transferredItems.next(transferredItems);
    this.setTransferredBadge(transferredItems.length);
  }
  setOrders(webOrder: WebOrder[]) {
    this.webOrders.next(webOrder);
    this.setOrdersBadge(webOrder.length);
  }

  setBasketData(basketData: Item) {
    this.basketData.next([...this.basketData.getValue(), basketData]);
  }
  setBasketDataArray(basketData: Item[]) {
    this.basketData.next(basketData);
  }
  clearBasket() {
    this.basketData.next([]);
  }
  startTimer() {
    merge(timer(0, 300000), this.manual$).subscribe(() => {
      this.storeService.listTransferItem().subscribe((res: TransferItem[]) => {
        this.setTransferredItems(res);
      });
      if (this.orderMenu?.title)
        this.saleService.listOrders().subscribe((orders) => {
          this.setOrders(orders);
        });
    });
  }
  getUser(): User {
    let usr = this.secure.get("app_run_time");
    if (usr) return JSON.parse(usr);
    else return usr;
  }
  //  someVariable$: Observable<TransferItem[]> = timer(0, 300000).pipe(
  //   startWith([]),
  //   distinctUntilChanged(),
  //   shareReplay({ bufferSize: 1, refCount: true }),
  //   map(e=>this.storeService.listTransferItem().pipe(map(d=>d)))
  // );
  setTransferedMenu(menuItem: NbMenuItem) {
    this.menuItem = menuItem;
  }
  setOrdersMenu(menuItem: NbMenuItem) {
    this.orderMenu = menuItem;
  }
  setTransferredBadge(count: number) {
    if (count === 0) this.menuItem.badge = undefined;
    else {
      this.menuItem.badge = {};
      this.menuItem.badge.status = "primary";
      this.menuItem.badge.text = count.toString();
    }
  }
  setOrdersBadge(count: number) {
    if (count === 0) this.orderMenu.badge = undefined;
    else {
      this.orderMenu.badge = {};
      this.orderMenu.badge.status = "primary";
      this.orderMenu.badge.text = count.toString();
    }
  }
  ngOnDestroy() {
    this.manual$.unsubscribe();
  }
}
